export const useLocalStorage = () => {
  const getLS = property => {
    return localStorage.getItem(property);
  };

  const setLS = (property, value) => {
    if (!value) {
      localStorage.removeItem(property);
    } else {
      localStorage.setItem(property, value);
    }
  };

  return { getLS, setLS };
};
